const o="roq-translation";export{o as LOCALE_STORAGE_KEY};